import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-elimination-form',
  templateUrl: './elimination-form.component.html',
  styleUrls: ['./elimination-form.component.css']
})
export class EliminationFormComponent implements OnInit {

  rForm: FormGroup;
  post: any;
  description: string = '';
  name: string = '';
  titleAlert:string = 'This field is required';
  topics = ['Misconduct', 'Other', 'I am currently a TelOne employee', 'N/A'];

  constructor(private fb: FormBuilder) {
    this.rForm = fb.group({
      'name': [null, Validators.required],
      'description': [null, Validators.compose([Validators.required, Validators.minLength(30), Validators.maxLength(500)])],
      'validate': ''
    });
   }
   addPost(post) {
    this.description = post.description;
    this.name = post.name;
  }

  ngOnInit(): void {
  }

}
